export default "__VITE_ASSET__BiZMNBtw__"